import list from './list'
import edit from './edit'
import create from './create'
import icon from '@material-ui/icons/Person'

const Brands = { list, edit, create, icon, options: { label: 'Brands' } }

export default Brands
